<template>
  <div :class="$style.wrapper">
    <section v-if="isUserLoaded" :class="$style.header">
      <div v-if="this.user?.photo_url" :class="$style.avatar">
        <img :src="this.user?.photo_url" alt="" />
      </div>
      <div v-else :class="$style.avatar">{{ initial }}</div>
      <h1 :class="$style.name">{{ username }}</h1>

      <div :class="$style.subline">
        <span>{{ roleLabel }}</span>
        <span v-if="this.user?.rating_count > 0" :class="$style.dot">•</span>
        <span v-if="this.user?.rating_count > 0" :class="$style.rating">{{ ratingText }}</span>
        <img
          v-if="this.user?.rating_count > 0"
          src="@/assets/img/account/star.svg"
          alt="star"
          :class="$style.star"
        />
      </div>

      <div v-if="moderationStatus === 'pending'" :class="$style.badgeRow">
        <span :class="$style.badgeWarn">
          На модерации
          <img src="@/assets/img/account/clock.svg" alt="clock" />
        </span>
        <button
          type="button"
          :class="$style.helpBtn"
          @click="showModerationInfo"
        >
          <img src="@/assets/img/account/info.svg" alt="" />
        </button>
      </div>
    </section>
    <section v-else :class="$style.headerSkeleton">
      <div :class="['skeleton', $style.avatarSkeleton]"></div>
      <div :class="['skeleton', $style.nameSkeleton]"></div>
      <div :class="['skeleton', $style.sublineSkeleton]"></div>
      <div :class="$style.badgeSkeletonRow">
        <span :class="['skeleton', $style.badgeSkeleton]"></span>
        <span :class="['skeleton', $style.badgeCircleSkeleton]"></span>
      </div>
    </section>

    <div v-if="this.user.type === 'seller'" :class="$style.deliveryTime">
      <p>Среднее время доставки товара</p>
      <div :class="$style.deliveryRight">
        <p>
          {{ this.user.delivery_time
          }}{{ this.user.delivery_type === "hours" ? "ч" : "д" }}
        </p>
        <button
          type="button"
          :class="$style.editDeliveryBtn"
          @click="openEditDeliveryTime"
        >
          <img src="@/assets/img/account/my-products/edit.svg" alt="" />
        </button>
      </div>
    </div>

    <!-- Тип аккаунта: переключение селлер/реселлер -->
    <div v-if="otherRole" :class="$style.roleSwitchCard">
      <div :class="$style.roleSwitchText">
        <p :class="$style.roleSwitchTitle">
          Тип аккаунта: {{ roleLabel }}
        </p>
        <p :class="$style.roleSwitchHint">
          {{
            otherRole.registered
              ? `Переключиться на роль «${roleLabelFor(otherRole.role)}». Данные текущей роли сохранятся.`
              : `Стать ${otherRole.role === "seller" ? "Селлером" : "Реселлером"} — упрощённая регистрация, телефон и почта общие.`
          }}
        </p>
      </div>
      <button
        type="button"
        :class="$style.roleSwitchBtn"
        :disabled="roleSwitching"
        @click="onRoleAction"
      >
        {{
          otherRole.registered
            ? `Переключиться на ${roleLabelFor(otherRole.role)}`
            : `Стать ${otherRole.role === "seller" ? "Селлером" : "Реселлером"}`
        }}
      </button>
    </div>

    <nav :class="$style.group">
      <router-link :class="$style.row" to="/personal-info">
        <span :class="$style.left">
          <span :class="$style.icWrap">
            <img src="@/assets/img/account/personal-info.svg" alt="" />
          </span>
          <span>Личные данные</span>
        </span>
        <span :class="$style.counter"></span>
        <img src="@/assets/img/account/chev.svg" alt="" :class="$style.chev" />
      </router-link>
    </nav>
    <nav v-if="this.user.type === 'seller'" :class="$style.group">
      <a
        :class="[$style.row, moderationStatus === 'pending' && $style.disabled]"
        :href="moderationStatus === 'pending' ? '#' : '/my-products'"
        @click.prevent="handleMyProductsClick"
      >
        <span :class="$style.left">
          <span :class="$style.icWrap">
            <img src="@/assets/img/account/products.svg" alt="products" />
          </span>
          <span>Мои товары</span>
        </span>
        <span :class="$style.counter">{{ myProductsCount }}</span>
        <img src="@/assets/img/account/chev.svg" alt="" :class="$style.chev" />
      </a>
    </nav>
    <nav :class="$style.group">
      <router-link :class="$style.row" to="/favorites">
        <span :class="$style.left">
          <span :class="$style.icWrap">
            <img src="@/assets/img/account/like.svg" alt="" />
          </span>
          <span>Избранное</span>
        </span>
        <span :class="$style.counter">{{ favoritesCount }}</span>
        <img src="@/assets/img/account/chev.svg" alt="" :class="$style.chev" />
      </router-link>
    </nav>
    <nav :class="$style.group">
      <router-link :class="$style.row" to="/notifications">
        <span :class="$style.left">
          <span :class="$style.icWrap">
            <img src="@/assets/img/account/like.svg" alt="" />
          </span>
          <span>Уведомления</span>
        </span>
        <span :class="$style.counter">{{ notificationsCount }}</span>
        <img src="@/assets/img/account/chev.svg" alt="" :class="$style.chev" />
      </router-link>
    </nav>

    <nav :class="$style.group">
      <a
        :class="$style.row"
        href="https://t.me/snkrroomru"
        @click.prevent="openSupport"
      >
        <span :class="$style.left">
          <span :class="$style.icWrap">
            <img src="@/assets/img/account/support.svg" alt="" />
          </span>
          <span>Поддержка</span>
        </span>
        <span :class="$style.counter"></span>
        <img src="@/assets/img/account/chev.svg" alt="" :class="$style.chev" />
      </a>

      <router-link :class="$style.row" to="/docs">
        <span :class="$style.left">
          <span :class="$style.icWrap">
            <img src="@/assets/img/account/docs.svg" alt="" />
          </span>
          <span>Документация</span>
        </span>
        <span :class="$style.counter"></span>
        <img src="@/assets/img/account/chev.svg" alt="" :class="$style.chev" />
      </router-link>

      <router-link :class="$style.row" to="/faq">
        <span :class="$style.left">
          <span :class="$style.icWrap">
            <img src="@/assets/img/account/faq.svg" alt="" />
          </span>
          <span>FAQ</span>
        </span>
        <span :class="$style.counter"></span>
        <img src="@/assets/img/account/chev.svg" alt="" :class="$style.chev" />
      </router-link>
    </nav>

    <div :class="$style.userId">ID: {{ userId }}</div>
  </div>
</template>

<script>
export default {
  name: "Account",
  data() {
    return {
      roleSwitching: false,
    }
  },
  computed: {
    data() {
      return this.$store.state.data
    },
    user() {
      return this.$store.state.user || {}
    },
    isUserLoaded() {
      return !!this.user?.id
    },
    username() {
      return this.user.login
    },
    initial() {
      return this.username?.trim()?.[0].toUpperCase()
    },
    roleLabel() {
      const t = this.user.type
      return t === "seller" ? "Селлер" : "Реселлер"
    },
    // Вторая роль (не активная): null, пока /user/roles не загрузился
    otherRole() {
      const roles = this.$store.state.userRoles?.roles
      if (!Array.isArray(roles)) return null
      const other = roles.find((r) => !r.active)
      return other || null
    },
    ratingText() {
      const r = Number(this.user.rating ?? 5).toFixed(1)
      return r
    },
    myProductsCount() {
      return this.$store.state.myProductsCount ?? 0
    },
    favoritesCount() {
      return this.$store.state.favorites.total || 0
    },
    notificationsCount() {
      return this.$store.state.notificationsCount ?? 0
    },
    userId() {
      return this.user.id
    },
    moderationStatus() {
      return this.user.moderation_status || "pending"
    },
  },
  async mounted() {
    await this.$store.dispatch("userMe")
    if (this.user.is_activated) {
      // Загружаем профиль для получения актуальных счетчиков
      await this.$store.dispatch("getProfile")
      // Доступные роли (селлер/реселлер) — для переключения типа аккаунта
      this.$store.dispatch("getUserRoles").catch(() => {})
    }
  },
  methods: {
    // Метка роли по значению (не roleLabel — то имя занято computed)
    roleLabelFor(role) {
      return role === "seller" ? "Селлер" : "Реселлер"
    },
    async onRoleAction() {
      const other = this.otherRole
      if (!other || this.roleSwitching) return

      if (other.registered) {
        await this.doSwitchRole(other.role)
      } else {
        await this.doRegisterRole(other.role)
      }
    },
    async doSwitchRole(role) {
      const tg = window.Telegram?.WebApp
      const confirmed = await new Promise((resolve) => {
        const msg =
          `Переключиться на роль «${this.roleLabelFor(role)}»?` +
          `\nДанные текущей роли сохранятся.`
        if (tg?.showPopup) {
          tg.showPopup(
            {
              title: "Смена типа аккаунта",
              message: msg,
              buttons: [
                { id: "yes", type: "default", text: "Да" },
                { type: "cancel", text: "Нет" },
              ],
            },
            (id) => resolve(id === "yes")
          )
        } else {
          resolve(window.confirm(msg))
        }
      })
      if (!confirmed) return

      this.roleSwitching = true
      try {
        await this.$store.dispatch("switchUserRole", { role })
        await this.$store.dispatch("getUserRoles").catch(() => {})
      } catch (error) {
        const detail = error?.response?.data?.detail || error?.message
        const message =
          typeof detail === "string"
            ? detail
            : "Не удалось переключить роль. Попробуйте позже."
        if (window.Telegram?.WebApp?.showPopup) {
          window.Telegram.WebApp.showPopup({
            title: "Ошибка",
            message,
            buttons: [{ type: "close", text: "Ок" }],
          })
        } else {
          window.alert(message)
        }
      } finally {
        this.roleSwitching = false
      }
    },
    async doRegisterRole(role) {
      if (role === "seller") {
        // Упрощённая регистрация селлера: единственный шаг — время доставки
        this.$router.push({ name: "BecomeSeller" })
        return
      }
      // Реселлеру ничего дополнительно не нужно — сразу подтверждение
      await this.doSwitchRoleRegister("reseller")
    },
    async doSwitchRoleRegister(role, payload = {}) {
      this.roleSwitching = true
      try {
        await this.$store.dispatch("registerUserRole", { role, ...payload })
        await this.$store.dispatch("getUserRoles").catch(() => {})
      } catch (error) {
        const detail = error?.response?.data?.detail || error?.message
        const message =
          typeof detail === "string"
            ? detail
            : "Не удалось зарегистрировать роль. Попробуйте позже."
        if (window.Telegram?.WebApp?.showPopup) {
          window.Telegram.WebApp.showPopup({
            title: "Ошибка",
            message,
            buttons: [{ type: "close", text: "Ок" }],
          })
        } else {
          window.alert(message)
        }
      } finally {
        this.roleSwitching = false
      }
    },
    openEditDeliveryTime() {
      this.$router.push({
        name: "EditDeliveryTime",
        query: {
          tab: this.user?.delivery_type === "days" ? "days" : "hours",
          hours:
            this.user?.delivery_type === "hours"
              ? String(this.user?.delivery_time || "")
              : undefined,
          days:
            this.user?.delivery_type === "days"
              ? String(this.user?.delivery_time || "")
              : undefined,
        },
      })
    },
    handleMyProductsClick() {
      if (this.moderationStatus === "pending") {
        return false
      }
      this.$router.push("/my-products")
    },
    showModerationInfo() {
      const tg = window.Telegram?.WebApp
      const userType = this.user.type
      let message = ""

      if (userType === "seller") {
        message =
          'Пока не пройдена модерация недоступен следующий функционал:\n\n• Нет доступа к странице "Сделки"\n• Нет доступа к разделу "Мои товары"'
      } else if (userType === "reseller") {
        message =
          'Пока не пройдена модерация недоступен следующий функционал:\n\n• Нет доступа к странице "Сделки"\n• Нет доступа к заявке и добавлению продукта в заявку'
      } else {
        message = "Пока не пройдена модерация недоступен следующий функционал."
      }

      if (tg?.showPopup) {
        tg.showPopup({
          title: "Информация",
          message: message,
          buttons: [{ type: "close", text: "Понятно" }],
        })
      } else {
        window.alert(message)
      }
    },
    openSupport() {
      const tg = window.Telegram?.WebApp
      const supportUrl = "https://t.me/snkrroomru"

      if (tg) {
        // Используем openTelegramLink для открытия чата внутри Telegram
        // openTelegramLink принимает https://t.me/ ссылки для открытия чатов
        if (tg.openTelegramLink) {
          try {
            tg.openTelegramLink(supportUrl)
          } catch (error) {
            // Если openTelegramLink не работает, используем openLink
            console.warn("openTelegramLink failed, using openLink:", error)
            if (tg.openLink) {
              tg.openLink(supportUrl)
            } else {
              window.open(supportUrl, "_blank")
            }
          }
        } else if (tg.openLink) {
          tg.openLink(supportUrl)
        } else {
          window.open(supportUrl, "_blank")
        }
      } else {
        // Fallback для браузера
        window.open(supportUrl, "_blank")
      }
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  padding: 1.25rem 1rem 6rem 1rem;
}

.header {
  display: grid;
  justify-items: center;
  margin-bottom: 1.25rem;
}

.avatar {
  width: 5.625rem;
  height: 5.625rem;
  border-radius: 50%;
  background: #111;
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 2.75rem;
  font-weight: 500;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.name {
  margin-top: 0.75rem;
  font-size: 1.5rem;
  line-height: 1.2;
  font-weight: 600;
  color: #000;
  text-align: center;
}

.subline {
  display: inline-flex;
  align-items: center;
  color: #9b9ba1;
  font-size: 1rem;
  margin: 0.25rem 0 0.5rem 0;
  .rating {
    color: #000;
  }
}
.dot {
  opacity: 0.7;
  padding: 0 0.5rem;
}
.star {
  width: 1rem;
  height: 1rem;
  fill: #ffb800;
  margin: 0 0 0 0.25rem;
}

.badgeRow {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.badgeWarn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.625rem;
  border-radius: 0.5rem;
  background: #eca0080d;
  color: #eca008;
  font-weight: 600;
  font-size: 0.875rem;
  img {
    width: 1rem;
    height: 1rem;
  }
}
.badgeWarn .i {
  width: 16px;
  height: 16px;
  fill: currentColor;
}

.helpBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.75rem;
  height: 1.75rem;
  background: transparent;
  border: none;
  padding: 0;
}
.helpBtn svg {
  width: 1.125rem;
  height: 1.125rem;
}
.deliveryTime {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background: #f5f7fa;
  border-radius: 0.625rem;
  margin: 0 0 1rem 0;
  p {
    display: flex;
    align-items: center;
    font-size: 1rem;
  }
}

.deliveryRight {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.editDeliveryBtn {
  border: none;
  background: transparent;
  padding: 0;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.editDeliveryBtn img {
  width: 1.5rem;
  height: 1.5rem;
  opacity: 0.7;
}

/* Тип аккаунта: переключение селлер/реселлер */
.roleSwitchCard {
  background: #f5f7fa;
  border-radius: 0.625rem;
  padding: 0.75rem 1rem;
  margin: 0 0 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.roleSwitchTitle {
  font-size: 1rem;
  font-weight: 600;
  color: #161616;
}

.roleSwitchHint {
  font-size: 0.8125rem;
  color: #6f6f78;
  line-height: 1.35;
}

.roleSwitchBtn {
  border: none;
  background: #161616;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0.625rem;
  padding: 0.625rem 1rem;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
  }
}

.group {
  background: #fff;
  border: 1px solid #ebeaea;
  border-radius: 0.625rem;
  overflow: hidden;
  margin: 0 0 1rem 0;
}
.row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  grid-template-rows: 1fr;
  align-items: center;
  gap: 0.625rem;
  padding: 0.5rem 1rem;
  color: #161616;
  text-decoration: none;
  border-bottom: 1px solid #ebeaea;
  font-size: 1rem;
}
.row:last-child {
  border-bottom: 0;
}
.row.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.left {
  display: inline-flex;
  align-items: center;
  gap: 1.25rem;
}
.icWrap {
  width: 1.875rem;
  height: 1.875rem;
  display: grid;
  place-items: center;
}
.icWrap img {
  width: 1.875rem;
  height: 1.875rem;
}

.counter {
  margin-left: auto;
  color: #161616;
  font-weight: 400;
  font-size: 1rem;
}

.chev {
  width: 0.5rem;
  height: 0.75rem;
}

.userId {
  text-align: center;
  color: #b2b2b2;
  font-size: 0.75rem;
  margin-top: 1rem;
}

.headerSkeleton {
  display: grid;
  justify-items: center;
  margin-bottom: 1.25rem;
  gap: 0.5rem;
}

.avatarSkeleton {
  width: 5.625rem;
  height: 5.625rem;
  border-radius: 50%;
}

.nameSkeleton {
  width: 50%;
  height: 1.5rem;
  border-radius: 0.5rem;
}

.sublineSkeleton {
  width: 70%;
  height: 1rem;
  border-radius: 0.5rem;
}

.badgeSkeletonRow {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.badgeSkeleton {
  width: 8rem;
  height: 2rem;
  border-radius: 0.5rem;
  display: inline-block;
}

.badgeCircleSkeleton {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  display: inline-block;
}
</style>
